module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm4.4 21.348c0 .592-.604.822-1.102.52l-8.826-5.318c-.498-.302-.546-.796-.048-1.1l8.898-5.318c.498-.302 1.078-.07 1.078.522v10.694z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-circle-1.js
// module id = 1220
// module chunks = 14